module.exports = __webpack_public_path__ + "static/media/Icona-8.64ab3d6d.svg";